const BASE_URL = 'https://towershibuya.jp/assets/images/common/'

const IMGS = {
  'topevents':'tit_event_b.png',
  'topnews':'tit_news_b.png',
  'toptousen':'tit_tousen_b.png',
  'events':'tit_event_b.png',
  'blog':'tit_vinyl_w.png',
  'kpopnews':'tit_kpopnews_b.png',
  'kpopevents':'tit_kpopevent_b.png',
  'tvevents':'tit_tvevent_b.png',
  'regulartv':'tit_regulartv_b.png',
  'MINATOMIRAI BRANCH':'tit_minatomirai_b.png',
  'SUNSHINECITY ALPA BRANCH':'tit_ikebukuro_b.png',
}

const LINKS = {
  'news':"/news",
  'kpopnews':'/kpop',
  'kpopevents':'/kpop',
  'topevents':"/events",
  'blog':"/blog",
  'tv':"towerrecordstv"
}

const BlockTitleCommon =({name, link, sub})=> {
  let img_src = sub && IMGS[sub] ? IMGS[sub] : IMGS[name] ? IMGS[name] : 'tit_sog_logo_b.png';
  return (<h2 className="text-6xl md:text-7xl font-bold tracking-tighter leading-tight">
      <a href={link} className="flex justify-end">
        <img alt={name} width={200} height={100} className="logo inactive" src={BASE_URL+img_src} />
      </a>
</h2>)
}


const BlockTitle=({type, title, sub})=> {
  const name = type ? type+title : title;
  const link = LINKS[name] || "/";
  return <BlockTitleCommon name={name} link={link} sub={sub} />
}

export default BlockTitle;
